import React from "react";
import "./index.css";
import { Language } from "../../types";
import { useContextProvider } from "../../context";
import carIcon from "./car.webp";
import clientIcon from "./client.webp";
import deliveryIcon from "./delivery.webp";
import gaugeIcon from "./gauge.webp";
import supportIcon from "./support.webp";
import { Item } from "./subComponents/item";

export const dict = {
  [Language.English]: {
    title: "Services",
    t1: "Free delivery and return of the car within 50 kilometers of Alicante.",
    t2: "Ability to deliver and return the car to any point in Spain",
    t3: "Individual approach to each client",
    t4: "Minimum driver age 25 years, minimum driving experience 2 years",
    t5: "24/7 support and assistance",
  },
  [Language.Spanish]: {
    title: "Servicios",
    t1: "Entrega y devolución gratuitas del coche en un radio de 50 kilómetros de Alicante.",
    t2: "Posibilidad de entrega y devolución del coche en cualquier punto de España",
    t3: "Acompañamiento personalizado para cada cliente",
    t4: "Edad mínima del conductor 25 años, experiencia mínima de conducción 2 años",
    t5: "Asistencia y soporte 24/7",
  },
  [Language.Russian]: {
    title: "Услуги",
    t1: "Бесплатная доставка и возврат автомобиля в радиусе 50 километров от Аликанте.",
    t2: "Возможность доставки и возврата автомобиля в любую точку Испании",
    t3: "Индивидуальный подход к каждому клиенту",
    t4: "Минимальный возраст водителя 25 лет, минимальный стаж вождения 2 года",
    t5: "Помощь и поддержка 24/7",
  },
  [Language.Ukrainian]: {
    title: "Послуги",
    t1: "Безплатна доставка і повернення автомобіля в радіусі 50 кілометрів від Аликанте.",
    t2: "Можливість доставки і повернення автомобіля в будь-яку точку Іспанії",
    t3: "Індивідуальний підхід до кожного клієнта",
    t4: "Мінімальний вік водія 25 років, мінімальний стаж водіння 2 роки",
    t5: "Допомога та підтримка 24/7",
  },
};

const services = [
  { key: "t1", icon: carIcon, alt: "car icon" },
  { key: "t2", icon: deliveryIcon, alt: "delivery icon" },
  { key: "t3", icon: clientIcon, alt: "client icon" },
  { key: "t4", icon: gaugeIcon, alt: "gauge icon" },
  { key: "t5", icon: supportIcon, alt: "support icon" },
] as const;

export const Services: React.FC = () => {
  const { language } = useContextProvider();
  return (
    <section className="Services">
      <div className="Services-container">
        <h2>{dict[language].title}</h2>
        {services.map(({ key, icon, alt }) => (
          <Item
            key={key}
            icon={icon}
            alt={alt}
            language={language}
            keyValue={key}
          />
        ))}
      </div>
    </section>
  );
};
